export const removeLoadingState = () => {
  document.querySelector("#landing-loader")?.remove();
  const reactApp = document.querySelector<HTMLDivElement>("#react_app");
  if (reactApp) {
    reactApp.style.display = "block";
  }
  document.querySelector("body")?.classList.add("body-loaded");
};
